export const IS_APPLE: boolean = /Mac|iPod|iPhone|iPad/.test(navigator.platform);

export function controlOrMeta(metaKey: boolean, ctrlKey: boolean): boolean {
    if (IS_APPLE) {
        return metaKey;
    }
    return ctrlKey;
}

export const MIDDLE_MOUSE_BUTTON = 1;

export function getWindowSelection(): Selection {
    const selection = window.getSelection();
    if (!selection) {
        // if we are in an iframe, Firefox will return null.
        // we should never be in an iframe.
        throw new Error('No selection');
    }
    return selection;
}
